<template>
  <div data-scroll-name="details">
    <section class="my-20">
      <Container className="lg:flex gap-24">
        <div
          class="flex-none w-full lg:w-80 lg:h-96 p-6 lg:p-10 mb-6 lg:mb-0 bg-none bg-right-bottom bg-no-repeat bg-contain"
          :class="{
            'bg-primary-color': !getPrimaryColor,
            [`bg-[${getPrimaryColor}]`]: getPrimaryColor,
            [`lg:bg-[url(${mask})]`]: true
          }"
        >
          <div class="flex items-center h-full">
            <div class="flex flex-col space-y-6 text-white">
              <div class="text-3xl lg:text-5xl">{{ addressPart1 }}</div>
              <div class="text-base">{{ addressPart2 }}</div>
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div v-if="getDetails.description.value">
            <p
              class="text-justify font-lato leading-7 tracking-wide text-secondary-color"
            >
              {{ getDetails.description.value }}
            </p>
          </div>

          <div class="mt-16 flex flex-wrap gap-x-6 gap-y-4">
            <div
              v-for="(detail, index) in list"
              :key="index"
              class="flex flex-wrap gap-x-1 text-xl"
            >
              <div
                class="text-slate-700 relative"
                :class="{
                  'text-primary-color': !getPrimaryColor,
                  [`text-[${getPrimaryColor}]`]: getPrimaryColor,
                }"
              >
                <span
                  class="absolute h-2 w-2 left-0 top-1/2 -translate-y-1/2"
                  :class="{
                    'bg-primary-color': !getPrimaryColor,
                    [`bg-[${getPrimaryColor}]`]: getPrimaryColor,
                  }"
                ></span>
                <span class="pl-4">{{ detail.label }}:</span>
              </div>
              <div class="text-secondary-color">
                {{ detail.value }}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import addressMixin from "@/shared/mixins/address";
import Container from "../../components/Container";
import mask from "./mask-group-1.png";

export default {
  name: "Details",
  mixins: [addressMixin],
  components: {
    Container,
  },
  data() {
    return {
      mask,
    };
  },
  computed: {
    ...mapGetters("tour", ["getDetails", "getPrimaryColor"]),
    list() {
      return (
        Object.values(this.getDetails).filter(
          (detail) => detail.label !== "Description" && detail.label !== "Address"
        ) || []
      );
    },
  },
};
</script>
